import * as Yup from 'yup'

import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
} from '../../Entity'
import {
  FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME,
  getFormikFormSelectFieldValidationSchema,
} from '../../Formik'

import {
  TASK_EDIT_MANAGER_FIELDS_FIELD_NAME,
  TASK_EDIT_MANAGER_FIELDS_INITIAL_VALUES,
} from './TaskEditManagerModal.constants'

export function getTaskEditManagerValidationSchema(t) {
  return Yup.object({
    [TASK_EDIT_MANAGER_FIELDS_FIELD_NAME]:
      getFormikFormSelectFieldValidationSchema({
        notSelectedValueErrorText: t(
          'Error.TaskEditPriorityNotSelectedValueFromListKey'
        ),
        required: true,
      }),
  })
}

export function getTaskEditManagerPayload(values) {
  return {
    [TASK_EDIT_MANAGER_FIELDS_FIELD_NAME]:
      values[TASK_EDIT_MANAGER_FIELDS_FIELD_NAME].value,
  }
}

export function getTaskEditManagerInitialValues() {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    ...TASK_EDIT_MANAGER_FIELDS_INITIAL_VALUES,
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]:
      actionTypeOptions[EntityActionTypeSelectOptionValue.Edit],
  }
}
